<template>
  <div class="form-group">
    <label v-if="label"
           :for="id"
           v-bind:class="{required: isRequired}">
      {{label}}
    </label>
    <select v-bind:value="value"
            v-bind="$attrs"
            v-on="selectListeners"
            :id="id"
            v-bind:class="{ 'is-invalid': validation.$error }"
            class="form-control">
      <option v-for="option in options"
              :selected="option.value === value"
              :disabled="readonly"
              :key="option.id"
              :value="option.value">
        {{option.text}}
      </option>
    </select>
    <div class="invalid-feedback" v-if="errorMessage">
      {{errorMessage}}
    </div>
  </div>
</template>

<script>
import { ValidationMixin } from '@/js/Mixins';

export default {
  name: 'base-select',
  inheritAttrs: false,
  mixins: [ValidationMixin],
  props: {
    label: String,
    value: String,
    options: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      default() {
        return {
          $error: false,
          $touch() {
          },
        };
      },
    },
  },
  mounted() {
    this.id = `select-${this._uid}`;
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    selectListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.validation.$touch();
          vm.$emit('input', event.target.value);
        },
        change: (event) => {
          vm.validation.$touch();
          vm.$emit('input', event.target.value);
        },
      });
    },
    isRequired() {
      return Object.prototype.hasOwnProperty.call(this.validation, 'required');
    },
  },
};
</script>
